import { combineReducers } from '@reduxjs/toolkit';
import admin from './admin-reducer';
import auth from './auth-reducer';
import stashcard from './stashcard-reducer';
import community from './community-reducer';
import categories from './category-reducer';

const rootReducer = combineReducers({
  admin,
  auth,
  stashcard,
  community,
  categories,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
